import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const quotationAttachment = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/quotation/{profile}/quotation-attachment',
    app: 'quotation',
    pk: 'id'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'quotation', model: 'quotation-attachment' }
    ),
    { }
  )
)()

export { quotationAttachment, TYPES }
